import { useEffect } from 'react';
import defaultBackground from '../../../pics/backgrounds/happyTavern.png';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import IconExample from './IconExample';
import EditPositionDropdown from './EditPositionDropdown';
import EditTvTablePositionDropdown from './EditTvTablePositionDropdown';
import magPlus from '../../../pics/icons/magPlus.PNG'
import magMinus from '../../../pics/icons/magMinus.PNG'
import OptionButton from '../OptionButton';


const capTitle = {
    'player': 'Player',
    'ally': 'Ally',
    'monster': 'Enemy',
}

const PlayerViewBloodPreview = ({
        label, 
        type, 
        username, 
        currentEncounter, 

        parentObject, 
        setParentObject,

        playerOptions,
        setPlayerOptions,

        allyOptions,
        setAllyOptions,

        monsterOptions,
        setMonsterOptions,

        allPosition,
        setAllPosition,

        tableViewOptions,
        setTableViewOptions,

        socket,
}) => {

    useEffect(() => {
        let playerViewKey = type === 'global' ? 'playerViewGlobalOptions' : 'playerViewOptions'
        setParentObject(
            {...parentObject,
                [playerViewKey]: {
                    playerOptions: {...playerOptions},
                    monsterOptions: {...monsterOptions},
                    allyOptions: {...allyOptions},
                    tableViewOptions: {...tableViewOptions}
                }
            });
        // eslint-disable-next-line
    }, [playerOptions, monsterOptions, allyOptions, tableViewOptions]);

    useEffect(() => {
        if(playerOptions.position === monsterOptions.position && playerOptions.position === allyOptions.position) {
            setAllPosition(playerOptions.position)
        } else {
            setAllPosition('Mixed')
        }
    }, [playerOptions.position, monsterOptions.position, allyOptions.position])


    // visualKey can be 'showHp', 'showHpBar', 'showBlood', 'showDead', 'position', 'teamSize', 'showSize', 'deathSaves', 'showName'
    // creatureType can be 'monster' or 'player' or 'ally' or 'tableView'
    const handlePvOptionChange = (creatureType, visualKey, value) => {
        if(visualKey === 'teamSize') {
            handlePvSizeChange(creatureType, visualKey, value)
            return;
        }

        // If setting all, first set all then call this function again for each creature alignment
        if(creatureType === 'all') {
            setAllPosition(value)
            handlePvOptionChange('player', visualKey, value)
            handlePvOptionChange('monster', visualKey, value)
            handlePvOptionChange('ally', visualKey, value)
            return;
        }

        if(creatureType === 'tableView') {
            setTableViewOptions({  
                ...tableViewOptions,
                [visualKey]: value
            })
        } else if(creatureType === 'player') {
            setPlayerOptions({  
                ...playerOptions,
                [visualKey]: value
            })
        } else if(creatureType === 'monster') {
            setMonsterOptions({
                ...monsterOptions,
                [visualKey]: value
            }) 
        } else if(creatureType === 'ally') {
            setAllyOptions({
                ...allyOptions,
                [visualKey]: value
            }) 
        } 

        if(type === 'global') {
            socket.emit("editPvGlobalOptions", creatureType, visualKey, value, username)
        } else {
            socket.emit("editPvOptions", creatureType, visualKey, value, parentObject.encounterGuid)
        }
    } 

    const handlePvSizeChange = (creatureType, visualKey, value) => {
        // player and ally size will be the same for this one, since its in groups
        if(creatureType === 'player') {
            value += parseInt(playerOptions.teamSize)
            setPlayerOptions({  
                ...playerOptions,
                [visualKey]: value
            })
        } else if(creatureType === 'ally') {
            value += parseInt(allyOptions.teamSize)
            setAllyOptions({  
                ...allyOptions,
                [visualKey]: value
            })
        } else if(creatureType === 'monster') {
            value += parseInt(monsterOptions.teamSize)
            setMonsterOptions({
                ...monsterOptions,
                [visualKey]: value
            }) 
        }

        if(type === 'global') {
            socket.emit("editPvGlobalOptions", creatureType, 'teamSize', value, username)
        } else {
            socket.emit("editPvOptions", creatureType, 'teamSize', value, parentObject.encounterGuid)
        }

    } 

    const isBackgroundImage = !currentEncounter.backgroundGuid.includes("www.youtube.com")

    return (
        <div className='globalTypeOptions'>
            <Tabs>
                <div className='globalOptionsTitleContainer'>
                    <div className='globalTitle'>{type === 'global' ? <b>{label}</b> : <><i>'{currentEncounter.encounterName}' </i><b> {label}</b></>}</div>
                    <div className='globalTitleDesc'>{type === 'global' ? 'When \'Use Global\' is checked' : 'When \'Use Global\' is un-checked'}</div>
                    <div className='globalTitleDesc'>{type === 'global' ? 'Global Options will apply to all encounters': 'Each Encounter will apply its own options'}</div>
                </div>
                
                <TabList>
                    <Tab>Players</Tab>
                    <Tab>Allies</Tab>
                    <Tab>Enemies</Tab>
                </TabList>
                <div className='playerViewOptionsContainer'>
                    <div className='playerViewOptions background' style={{backgroundImage: isBackgroundImage ? `url(${currentEncounter.backgroundGuid})` : `url(${defaultBackground})`}}>
                        <div className="iconOptionsFlag"/>
                        <TabPanel key={'playerTab'}>
                            <div className={'playerOptionsTabPanel'}>
                                <IconExample currentEncounter={currentEncounter} creatureType={'player'} iconOptions={playerOptions}/>
                                <div className='playerViewOptionsChecks editBlockTitle'> 
                                    <div className='pVChecks pVCheckLeft '> 
                                        {parseInt(playerOptions.teamSize) < 0 && 
                                            <span  style={{fontSize: '10px', color: 'black'}}>
                                                ({playerOptions.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                                            </span>
                                        }
                                        &nbsp;Shrink&nbsp;<OptionButton imgClassName={'magOptionsSmall'} src={magMinus} message={`Shrink ${capTitle['player']} Icons`} onClickFunction={()=> handlePvOptionChange('player', 'teamSize', -1)}/>
                                    </div>
                                    <div className='pVChecks'> 
                                        <OptionButton imgClassName={'magOptionsSmall'} src={magPlus} message={`Grow ${capTitle['player']} Icons`} onClickFunction={()=> handlePvOptionChange('player', 'teamSize', 1)}/>&nbsp;Grow
                                        &nbsp;{parseInt(playerOptions.teamSize) > 0 && 
                                            <span  style={{fontSize: '10px', color: 'black'}}>
                                                ({playerOptions.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                                            </span>
                                        }
                                    </div>
                                    <div className='pVChecks pVCheckLeft '> 
                                        Hp <input type="checkbox" checked={playerOptions.showHp} onChange={(e) => handlePvOptionChange('player', 'showHp', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks '> 
                                        <input type="checkbox" checked={playerOptions.showHpBar} onChange={(e) => handlePvOptionChange('player', 'showHpBar', e.target.checked)}/> Hp Bar 
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Blood <input type="checkbox" checked={playerOptions.showBlood} onChange={(e) => handlePvOptionChange('player', 'showBlood', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks ' style={{fontSize: "11px"}}> 
                                        <input type="checkbox" checked={playerOptions.showDead} onChange={(e) => handlePvOptionChange('player', 'showDead', e.target.checked)}/> Show Dead 
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Size <input type="checkbox" checked={playerOptions.showSize} onChange={(e) => handlePvOptionChange('player', 'showSize', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks' style={{fontSize: "11px"}}> 
                                    <input type="checkbox" checked={playerOptions.deathSaves} onChange={(e) => handlePvOptionChange('player', 'deathSaves', e.target.checked)}/> Death Saves 
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel key={'allyTab'}>
                            <div className={'playerOptionsTabPanel'}>
                                <IconExample currentEncounter={currentEncounter} creatureType={'ally'} iconOptions={allyOptions}/>
                                <div className='playerViewOptionsChecks editBlockTitle'> 
                                    <div className='pVChecks pVCheckLeft '> 
                                        {parseInt(allyOptions.teamSize) < 0 && 
                                            <span  style={{fontSize: '10px', color: 'black'}}>
                                                ({allyOptions.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                                            </span>
                                        }
                                        &nbsp;Shrink&nbsp;<OptionButton imgClassName={'magOptionsSmall'} src={magMinus} message={`Shrink ${capTitle['ally']} Icons`} onClickFunction={()=> handlePvOptionChange('ally', 'teamSize', -1)}/>
                                    </div>
                                    <div className='pVChecks'> 
                                        <OptionButton imgClassName={'magOptionsSmall'} src={magPlus} message={`Grow ${capTitle['ally']} Icons`} onClickFunction={()=> handlePvOptionChange('ally', 'teamSize', 1)}/>&nbsp;Grow
                                        &nbsp;{parseInt(allyOptions.teamSize) > 0 && 
                                            <span  style={{fontSize: '10px', color: 'black'}}>
                                                ({allyOptions.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                                            </span>
                                        }
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Hp <input type="checkbox" checked={allyOptions.showHp} onChange={(e) => handlePvOptionChange('ally', 'showHp', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks '> 
                                        <input type="checkbox" checked={allyOptions.showHpBar} onChange={(e) => handlePvOptionChange('ally', 'showHpBar', e.target.checked)}/> Hp Bar 
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Blood <input type="checkbox" checked={allyOptions.showBlood} onChange={(e) => handlePvOptionChange('ally', 'showBlood', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks ' style={{fontSize: "11px"}}> 
                                        <input type="checkbox" checked={allyOptions.showDead} onChange={(e) => handlePvOptionChange('ally', 'showDead', e.target.checked)}/> Show Dead 
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Size <input type="checkbox" checked={allyOptions.showSize} onChange={(e) => handlePvOptionChange('ally', 'showSize', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks ' style={{fontSize: "11px"}}> 
                                        <input type="checkbox" checked={allyOptions.showName} onChange={(e) => handlePvOptionChange('ally', 'showName', e.target.checked)}/> Real Name
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel key={'monsterTab'}>
                            <div className={'playerOptionsTabPanel'}>
                                <IconExample currentEncounter={currentEncounter} creatureType={'monster'} iconOptions={monsterOptions}/>
                                <div className='playerViewOptionsChecks editBlockTitle'> 
                                    <div className='pVChecks pVCheckLeft '> 
                                        {parseInt(monsterOptions.teamSize) < 0 && 
                                            <span  style={{fontSize: '10px', color: 'black'}}>
                                                ({monsterOptions.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                                            </span>
                                        }
                                        &nbsp;Shrink&nbsp;
                                        <OptionButton imgClassName={'magOptionsSmall'} src={magMinus} message={`Shrink ${capTitle['monster']} Icons`} onClickFunction={()=> handlePvOptionChange('monster', 'teamSize', -1)}/>
                                    </div>
                                    <div className='pVChecks'> 
                                        <OptionButton imgClassName={'magOptionsSmall'} src={magPlus} message={`Grow ${capTitle['monster']} Icons`} onClickFunction={()=> handlePvOptionChange('monster', 'teamSize', 1)}/>&nbsp;Grow
                                        &nbsp;{parseInt(monsterOptions.teamSize) > 0 && 
                                            <span  style={{fontSize: '10px', color: 'black'}}>
                                                ({monsterOptions.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                                            </span>
                                        }
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Hp <input type="checkbox" checked={monsterOptions.showHp} onChange={(e) => handlePvOptionChange('monster', 'showHp', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks '> 
                                        <input type="checkbox" checked={monsterOptions.showHpBar} onChange={(e) => handlePvOptionChange('monster', 'showHpBar', e.target.checked)}/> Hp Bar 
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Blood <input type="checkbox" checked={monsterOptions.showBlood} onChange={(e) => handlePvOptionChange('monster', 'showBlood', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks ' style={{fontSize: "11px"}}> 
                                        <input type="checkbox" checked={monsterOptions.showDead} onChange={(e) => handlePvOptionChange('monster', 'showDead', e.target.checked)}/> Show Dead 
                                    </div>
                                    <div className='pVChecks pVCheckLeft'> 
                                        Size <input type="checkbox" checked={monsterOptions.showSize} onChange={(e) => handlePvOptionChange('monster', 'showSize', e.target.checked)}/>
                                    </div>
                                    <div className='pVChecks ' style={{fontSize: "11px"}}> 
                                        <input type="checkbox" checked={monsterOptions.showName} onChange={(e) => handlePvOptionChange('monster', 'showName', e.target.checked)}/> Real Name
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </div>
                </div>
            </Tabs>           
            <Tabs>
                <TabList>
                    <Tab>PlayerView</Tab>
                    <Tab>Tv-Table View</Tab>
                </TabList>
                <TabPanel key={'playerViewTab'}>
                    <div className='viewTypeOptions'>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', height: '60px'}}>
                            <div className='pVChecks' style={{position: 'relative'}}> 
                                <div style={{textUnderlineOffset: '3px', textDecoration: 'underline', textDecorationColor: '#881810ff'}}>
                                    <b>All Icons</b>
                                </div>
                                <EditPositionDropdown creatureType={'all'} current={allPosition} handlePvOptionChange={handlePvOptionChange}/>
                            </div>

                            
                        </div>

                        <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                            <div className='pVChecks pVCheckLeft' style={{position: 'relative'}}> 
                                <b>Players </b>
                                {parseInt(playerOptions.teamSize) !== 0 && 
                                    <span  style={{fontSize: '11px', color: 'black'}}>
                                        (<b>{playerOptions.teamSize}</b><span style={{fontSize: '9px'}}>x</span>) 
                                    </span>
                                }
                                <EditPositionDropdown creatureType={'player'} current={playerOptions.position} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                            <div className='pVChecks pVCheckLeft' style={{position: 'relative'}}> 
                                <b>Allies </b>
                                {parseInt(allyOptions.teamSize) !== 0 && 
                                    <span  style={{fontSize: '11px', color: 'black'}}>
                                        (<b>{allyOptions.teamSize}</b><span style={{fontSize: '9px'}}>x</span>) 
                                    </span>
                                }
                                <EditPositionDropdown creatureType={'ally'} current={allyOptions.position} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                            <div className='pVChecks pVCheckLeft' style={{position: 'relative'}}> 
                                <b>Enemies </b>
                                {parseInt(monsterOptions.teamSize) !== 0 && 
                                    <span  style={{fontSize: '11px', color: 'black'}}>
                                        (<b>{monsterOptions.teamSize}</b><span style={{fontSize: '9px'}}>x</span>) 
                                    </span>
                                }
                                <EditPositionDropdown creatureType={'monster'} current={monsterOptions.position} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                        </div>
                        
                    </div>
                </TabPanel>

                <TabPanel key={'tvTableView'}>
                    <div style={{
                        display: 'flex', 
                        fontSize: '12px', 
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        margin: '0px 0px 0px 0px', 
                        padding: '5px', 
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: '5px'
                    }}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: '60px', width: '100%'}}>
                            <div className='pVChecks' style={{position: 'relative'}}> 
                                <div style={{textUnderlineOffset: '3px', textDecoration: 'underline', textDecorationColor: '#881810ff'}}>
                                    <b>All Icons</b>
                                </div> 
                                <EditTvTablePositionDropdown creatureType={'all'} currentSides={tableViewOptions.position.split(',')} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            </Tabs>
        </div>
    );
}

export default PlayerViewBloodPreview;